import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from 'stores/session';
import { STitle, SSubTitle } from './styles';
import Coffee1 from 'images/illustrations/Coffee1.svg?react';
import Coffee2 from 'images/illustrations/Coffee2.svg?react';
import TopBanner from 'components/TopBanner';

const Welcome: FC = () => {
    const { t } = useTranslation();
    const user = useSessionStore((s) => s.user);

    if (!user) {
        return null;
    }

    return (
        <TopBanner>
            <Coffee1 />
            <STitle>
                {t('home.hello', { who: user.firstName })}
                <SSubTitle>{t('home.good-day-is-coming')}</SSubTitle>
            </STitle>
            <Coffee2 />
        </TopBanner>
    );
};

export default Welcome;
